import React, { useEffect } from "react";
import { JobsStatusDonutModel } from "../../models/AdminDashboardModel";

type Props = {
    model?: JobsStatusDonutModel
}

function JobsStatusDonut(props: Props) {

    useEffect(() => {
        if (!props.model) return;
        const KTUtil = (window as any).KTUtil;
        if (!KTUtil || !window.createCircleChart) return;
        const colors = [
            KTUtil.getCssVariableValue("--bs-primary"),
            KTUtil.getCssVariableValue("--bs-warning"),
            KTUtil.getCssVariableValue("--bs-success"),
            KTUtil.getCssVariableValue("--bs-danger"),
        ];
        const values = [props.model.open, props.model.inProgress, props.model.completed, props.model.canceled];
        window.createCircleChart("jobs-status-donut", values, colors);
    }, [props.model]);

    const m = props.model;

    const rows: { label: string; value: number; color: string }[] = [
        { label: "Open", value: m?.open ?? 0, color: "primary" },
        { label: "In Progress", value: m?.inProgress ?? 0, color: "warning" },
        { label: "Completed", value: m?.completed ?? 0, color: "success" },
        { label: "Canceled", value: m?.canceled ?? 0, color: "danger" },
    ];

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Jobs by Status</h3>
                    <div className="widget-subtitle">{m?.total ?? 0} total jobs</div>
                </div>
            </div>
            <div className="card-body pt-3 d-flex align-items-center">
                <div id="jobs-status-donut" data-kt-size="120" data-kt-line="14" />
                <div className="ms-auto flex-grow-1 ps-4">
                    {rows.map(r => (
                        <div key={r.label} className="d-flex align-items-center my-2">
                            <span className={`status-dot bg-${r.color}`} />
                            <span className="text-gray-600 flex-grow-1 fs-7">{r.label}</span>
                            <span className="fw-bold text-gray-800 fs-7">{r.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default JobsStatusDonut;
